import fp from 'lodash/fp';
import * as actions from './actions';
import * as constants from './constants';
import { combineColumnPreferences } from '../../../common/saveconfiguration/utils';

export const INITIAL_STATE = {
    columns: constants.columns,
    loading: false,
    impactSummaryRows: [],
    impactSummaryLoaded: false,
    initialised: false,
    savedFilters: { counterparties: [], csas: [] },
    showAllRows: false,
    expandRows: {
        IM: true,
        Monitoring: true,
        Dummy: true,
        Selected: true
    }
};

const setLoading = fp.set('loading');
const setColumns = fp.set('columns');
const setRows = fp.set('impactSummaryRows');
const setImpactSummaryLoaded = fp.set('impactSummaryLoaded');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_INITIALISE: {
            return fp.set('initialised', true)(state);
        }
        case actions.SET_LOADING: {
            return setLoading(action.loading, state);
        }
        case actions.SET_IMPACT_SUMMARY_COLUMNS: {
            return setColumns(
                combineColumnPreferences(INITIAL_STATE.columns, action.data),
                state
            );
        }
        case actions.SET_DEFAULT_CONFIG: {
            return {
                ...state,
                columns: action.columns && action.columns.length
                    ? combineColumnPreferences(INITIAL_STATE.columns, action.columns)
                    : INITIAL_STATE.columns
            };
        }
        case actions.SET_IMPACT_SUMMARY_ROWS: {
            return setRows(action.data, state);
        }
        case actions.SET_IMPACT_SUMMARY_LOADED: {
            return setImpactSummaryLoaded(action.loaded, state);
        }
        case actions.SET_SAVED_FILTERS: {
            return fp.flow(
                fp.set('savedFilters.csas', action.csas),
                fp.set('savedFilters.counterparties', action.counterparties)
            )(state);
        }
        case actions.SET_SHOW_ALL_ROWS: {
            return {
                ...state,
                showAllRows: action.checked
            };
        }
        case actions.EXPAND_ROWS: {
            const rowId = action.id;
            const currentState = fp.get(`expandRows.${rowId}`)(state);
            return fp.set(`expandRows.${rowId}`, !currentState)(state);
        }
        default:
            return state;
    }
}
